/**
 * VERSIONE LIBRERIA 3
 */
var RenderChoice = Render.extend({
    type : 'choice',
    classData : 'choice',
    classTemplate : 'choice',
    choiceType : null,
    operator : null,
    domainValuesOrder : null,
    domainValues: null,

    _validateEdit : function () {
        var self = this;
        if (!self.domainValues || Object.keys(self.domainValues).length == 0 )  {
            self.domainValues = {1 : "Si",0 : "No"};
            log.warn("RenderChoice " + self.key + " no domainValues found use default",self.domainValues);
        }
        return true;
    },
    _renderEdit : function (jQe) {
        var self = this;
        var name = self.key;
        if (self.choiceType == 'checkbox')
            name+="[]";
        var exists = self.key.indexOf('[]') > 0?self.key.slice(0,-2)+'_exists[]':self.key+'_exists';
        if (self.multiple){
            name += '[]';
        }
        self._setData(jQe,name);
        var el = jQe.find(self.element_selector);
        $('<input>').attr({
            type: 'hidden',
            name: exists,
            value : 1
        }).appendTo(jQe);
    },
    _renderSearch : function(jQe) {
        var self = this;
        self._setData(jQe,'s_' + self.key + '[]');
        var el = jQe.find(self.element_selector);
        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + '_operator',
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
    },

    _setData : function (jQe,inputName) {
        var self = this;
        var el = jQe.find(self.element_selector);
        switch(self.choiceType ) {
            case 'checkbox':
            case 'radio':
                var localEl = el;

                //ORDINAMENTO DELLE CASELLE
                var vs = [];
                if (self.domainValuesOrder) {
                    vs = self.domainValuesOrder;
                } else {
                    vs = _.sortBy(_.keys(self.domainValues), function (num) {
                        return num;
                    });
                }

                for (var j = 0; j < vs.length; j++) {
                    //for (var v in self.data.domainValues) {
                    var v = vs[j];
                    var selected = false;
                    if (j>0) {
                        localEl = localEl.clone().appendTo(el.parent());
                    }
                    if (self.choiceType == 'checkbox') {
                        if ($.inArray(v, self.value) >= 0) {
                            selected = true;
                        }
                    } else {
                        if (v == self.value) {
                            selected = true;
                        }
                    }
                    //var name = self.key;
                    //if (self.config.mode == Render.SEARCH)
                    //    name = 's_' + self.key + '[]';
                    localEl.find(self.control_selector).attr('name',inputName).attr('value',v).attr('type',self.choiceType);
                    localEl.find(self.caption_selector).html(self.domainValues[v]);
                    localEl.addClass(self.choiceType);
                    if (selected ) {
                        localEl.find(self.control_selector).attr("checked", "checked");
                    } else {
                        localEl.find(self.control_selector).removeAttr("checked");
                    }
                }
                break;
            default:
                throw "choiceType " + self.choiceType +  " RenderChoice not implemented";
                break;
        }
    },
    _finalizeEdit : function(){},
    _finalizeSearch : function (){}
});